<template>
    <div id="notfound-page">
        <AppHero
            :heading="'404'"
            class="not-found-hero"
        >
            <p class="body-copy body-copy--align-center">You didnt break the internet,but we cant find what you are looking for.</p>

            <div class="center-button">
                <AppButton :text="'Go back to Home page'" :link="'/'" class="not-found-hero__btn"/>
            </div>
        </AppHero>
    </div>
</template>

<script>
    import AppHero from "@/components/layout/AppHero";
    import AppButton from "@/components/ui/AppButton";

    export default {
        name: 'NotFound',
        metaInfo: {
            title: 'Khonsu - NotFound'
        },
        components: {
            AppHero,
            AppButton
        },
        data: function () {
            return {}
        },
        methods: {
            submitForm:function () {
                window.location.href = "/";
            }
        }

    }
</script>

<style lang="scss">
    #setting-page {
        padding-bottom: 100px

    }

</style>
